export default "__VITE_ASSET__7a150543__"